import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const REQUEST = 'LOAD_WORK_DAYS_REQUEST';
export const SUCCESS = 'LOAD_WORK_DAYS_SUCCESS';
export const FAIL = 'LOAD_WORK_DAYS_FAIL';

export const SUBMIT_REQUEST = 'SUBMIT_WORK_DAY_REQUEST';
export const SUBMIT_SUCCESS = 'SUBMIT_WORK_DAY_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_WORK_DAY_FAIL';

export const UPDATE_REQUEST = 'UPDATE_WORK_DAY_REQUEST';
export const UPDATE_SUCCESS = 'UPDATE_WORK_DAY_SUCCESS';
export const UPDATE_FAIL = 'UPDATE_WORK_DAY_FAIL';

export const DELETE_REQUEST = 'DELETE_WORK_DAY_REQUEST';
export const DELETE_SUCCESS = 'DELETE_WORK_DAY_SUCCESS';
export const DELETE_FAIL = 'DELETE_WORK_DAY_FAIL';

export const EVENTS_REQUEST = 'LOAD_WORK_DAY_EVENTS_REQUEST';
export const EVENTS_SUCCESS = 'LOAD_WORK_DAY_EVENTS_SUCCESS';
export const EVENTS_FAIL = 'LOAD_WORK_DAY_EVENTS_FAIL';

export const RECURRING_TYPES_SUCCESS = 'LOAD_RECURRING_TYPES_SUCCESS';

export const WORK_DAY_EVENT_TYPES_SUCCESS = 'LOAD_WORK_DAY_EVENT_TYPES_SUCCESS';

const loadWorkDaysRequest = () => ({ type: REQUEST });
const loadWorkDaysSuccess = (workDays) => ({ type: SUCCESS, workDays });
const loadWorkDaysFail = (error) => ({ type: FAIL, error });

const submitWorkDayRequest = () => ({ type: SUBMIT_REQUEST });
const submitWorkDaySuccess = (workDay) => ({ type: SUBMIT_SUCCESS, workDay });
const submitWorkDayFail = (error) => ({ type: SUBMIT_FAIL, error });

const updateWorkDayRequest = () => ({ type: UPDATE_REQUEST });
const updateWorkDaySuccess = (workDay) => ({ type: UPDATE_SUCCESS, workDay });
const updateWorkDayFail = (error) => ({ type: UPDATE_FAIL, error });

const deleteWorkDayRequest = () => ({ type: DELETE_REQUEST });
const deleteWorkDaySuccess = (workDayId) => ({ type: DELETE_SUCCESS, workDayId });
const deleteWorkDayFail = (error) => ({ type: DELETE_FAIL, error });

const loadWorkDayEventsRequest = () => ({ type: EVENTS_REQUEST });
const loadWorkDayEventsSuccess = (events) => ({ type: EVENTS_SUCCESS, events });
const loadWorkDayEventsFail = (error) => ({ type: EVENTS_FAIL, error });

const loadRecurringTypesSuccess = (types) => ({ type: RECURRING_TYPES_SUCCESS, types });

const loadWorkDayEventTypesSuccess = (types) => ({ type: WORK_DAY_EVENT_TYPES_SUCCESS, types });

export const getWorkDays = (period) => communicate({
  url: 'WorkDays', method: 'get', getParams: `?period=${period}`
});

export const loadWorkDays = (period) => (dispatch) => {
  dispatch(loadWorkDaysRequest());
  getWorkDays(period)
    .then((response) => {
      dispatch(loadWorkDaysSuccess(response.data.Data));
    })
    .catch((err) => {
      dispatch(loadWorkDaysFail(err));
      toastrError(err);
    });
};

export const loadWorkDayEvents = () => (dispatch) => {
  dispatch(loadWorkDayEventsRequest());
  communicate({
    url: 'WorkDayEvents', method: 'get', getParams: '?deleted=false'
  })
    .then((response) => {
      dispatch(loadWorkDayEventsSuccess(response.data.Data));
    })
    .catch((err) => {
      dispatch(loadWorkDayEventsFail(err));
      toastrError(err);
    });
};

export const loadRecurringTypes = () => (dispatch) => {
  communicate({
    url: 'RecurringTypes'
  })
    .then((response) => {
      dispatch(loadRecurringTypesSuccess(response.data.Data));
    })
    .catch((err) => {
      console.error('Failed to load recurring types', err);
      toastrError(err);
    });
};

export const loadWorkDayEventTypes = () => (dispatch) => {
  communicate({
    url: 'WorkDayEventTypes'
  })
    .then((response) => {
      dispatch(loadWorkDayEventTypesSuccess(response.data.Data));
    })
    .catch((err) => {
      console.error('Failed to load work day event types', err);
      toastrError(err);
    });
};

export const submitWorkDayEvent = (workDayEvent, period) => (dispatch) => {
  dispatch(submitWorkDayRequest());
  communicate({
    url: 'WorkDayEvents', method: 'post', data: workDayEvent
  }).then((response) => {
    dispatch(submitWorkDaySuccess(response.data.Data));
    dispatch(loadWorkDays(period));
    toastrSuccess(response);
  }).catch((err) => {
    toastrError(err);
    console.error(err);
    dispatch(submitWorkDayFail(err));
  });
};

export const updateWorkDayEvent = (workDayEvent, period) => (dispatch) => {
  dispatch(updateWorkDayRequest());
  communicate({
    url: 'WorkDayEvents', method: 'put', data: workDayEvent
  }).then((response) => {
    dispatch(updateWorkDaySuccess(response.data.Data));
    dispatch(loadWorkDays(period));
    toastrSuccess(response);
  }).catch((err) => {
    toastrError(err);
    dispatch(updateWorkDayFail(err));
  });
};

export const deleteWorkDayEvent = (workDayEventId, period) => (dispatch) => {
  dispatch(deleteWorkDayRequest());
  communicate({
    url: 'WorkDayEvents', method: 'delete', getParams: `?id=${workDayEventId}`
  }).then((response) => {
    dispatch(deleteWorkDaySuccess(workDayEventId));
    dispatch(loadWorkDays(period));
    toastrSuccess(response);
  }).catch((err) => {
    toastrError(err);
    dispatch(deleteWorkDayFail(err));
  });
};
